// extracted by mini-css-extract-plugin
module.exports = {"grid":"submissions_grid__3HeEb","item":"submissions_item__36jvv","options":"submissions_options__2xWaN"};